import getSelectedVariantIdFromUrlProductUtil from 'modules/product/utils/get-selected-variant-id-from-url'

/**
 * @param props
 * @param props.variantId
 * @param props.fromSidebar
 * @returns {(function(*, *): void)|*}
 */
export default function getVariantIdUpdateSelectedColorVariantIdVariantActionUtil ({
  fromSidebar,
  variantId
}) {
  const selectedVariantIdFromUrl = getSelectedVariantIdFromUrlProductUtil()

  let selectedVariantIdNumber
  if (
    selectedVariantIdFromUrl &&
    !fromSidebar
  ) {
    selectedVariantIdNumber = Number(selectedVariantIdFromUrl)
  }

  if (
    selectedVariantIdNumber &&
    !isNaN(selectedVariantIdNumber)
  ) {
    variantId = selectedVariantIdNumber
  }

  return variantId
}
